import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { Translation } from 'react-i18next'
import { useForm, Form, Field } from '../../form'
import { passwordValidate } from '../../containers/validate'

class Password extends React.Component {
  render() {
    return <PasswordComponent {...this.props} />
  }
}

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  button: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    float: 'right',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
})

const defaultValues = {
  current_pw: '',
  new_pw: '',
  check_pw: ''
}

const PasswordComponent = ({
  passwordUpdate,
  showSnackbar,
  showFailSnackbar,
  closePasswordSnackbar,
  classes,
  userType
}) => {
  const form = useForm({
    name: 'password',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: passwordValidate
  })

  const { control } = form

  function onSubmit(values) {
    passwordUpdate(values)
  }

  const isMobile = window.innerWidth <= 768


  return (
    <Translation>
      {(t) => {
        return (
          <div className="dashboard-content-header">
            <Form {...form}>
              <div className="col-xs-12 col-sm-12 col-lg-12" style={{maxHeight: !isMobile && '360px', padding: 0}}>
                <div className="panel panel-default">
                  <div className="dashboard-content-header">
                    <h1>{t('TaxPassword.h3')}</h1>
                  </div>
                  <div className="panel-body" style={{ padding: '0px 15px', fontWeight: 600}}>
                    <div style={{ display: 'flex', marginBottom: '-12px', justifyContent: 'center', maxHeight: !isMobile && '90px' }}>
                      <p style={{ marginRight: '60px' }}>
                        {t('TaxPassword.p')}
                      </p>
                      <ul>
                        <li>{t('TaxPassword.li')}</li>
                        <li>{t('TaxPassword.li2')}</li>
                        <li>{t('TaxPassword.li3')}</li>
                      </ul>
                    </div>
                    <div style={{display: isMobile ? 'block' : 'flex', flexDirection: !isMobile && 'row', gap: 16, fontWeight: 600}}>
                      <Field
                        name="current_pw"
                        label={t('TaxPassword.label')}
                        type="password"
                        inputType="textfield"
                        control={control}
                        disabled={userType == 2}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                      />
                      <Field
                        name="new_pw"
                        label={t('TaxPassword.label2')}
                        type="password"
                        inputType="textfield"
                        control={control}
                        disabled={userType == 2}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                      />
                      <Field
                        name="check_pw"
                        label={t('TaxPassword.label3')}
                        type="password"
                        inputType="textfield"
                        control={control}
                        disabled={userType == 2}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                      />
                    </div>
                    <div className="button-pull">
                      <Button
                        disabled={userType == 2}
                        variant="contained"
                        type="submit"
                        className={classes.button}
                      >
                        {t('TaxPassword.button')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closePasswordSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closePasswordSnackbar()
                }}
                variant="success"
                message={t('TaxPassword.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closePasswordSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closePasswordSnackbar()
                }}
                variant="error"
                message={t('TaxPassword.msg2')}
              />
            </Snackbar>
          </div>
        )
      }}
    </Translation>
  )
}

Password.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Password)
